export default __webpack_public_path__ + "static/media/boberContent2.7ad3047d.mp4";